import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PageContentModule, TableContainerModule } from '@meddatacore/components';
import { ConfirmationDialogModule, PipesModule } from '@meddatacore/shared';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MeddataThemeModule } from '@meddatacore/ui';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMaskModule } from 'ngx-mask';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatTableFilterModule } from '@meddatacore/shared';
import { SetPasswordModalComponent } from './components/set-password-modal/set-password-modal.component';
import { TranslateModule } from '@ngx-translate/core';
const materialGridModules = [
  MatPaginatorModule,
  MatTableModule,
  MatSortModule,
  MatTableFilterModule
];
const materialModules = [
  MatButtonModule,
  MatInputModule,
  MatListModule,
  MatCardModule,
  MatMenuModule,
  MatIconModule,
  MatTooltipModule,
  MatDatepickerModule,
  MatNativeDateModule,
  NgxMaskModule.forRoot(),
  MatButtonToggleModule,
  MatFormFieldModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  MatSelectModule,
  MatRadioModule,
  MatDialogModule,
  MatPaginatorModule
];
@NgModule({
  declarations: [SetPasswordModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    materialModules,
    materialGridModules,
    MatSnackBarModule,
    NgxSpinnerModule,
    TableContainerModule,
    PageContentModule,
    ConfirmationDialogModule,
    PipesModule,
    MeddataThemeModule,
    TranslateModule.forChild()
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    materialModules,
    materialGridModules,
    MatSnackBarModule,
    TableContainerModule,
    PageContentModule,
    ConfirmationDialogModule,
    PipesModule,
    // NgxPermissionsModule,
    MeddataThemeModule,
    SetPasswordModalComponent
  ]
})
export class SharedModule { }
